<!-- src/app/components/donate-banner/donate-banner.component.html -->
<div *ngIf="visible" class="donate-banner" role="region" aria-label="Donation appeal">
  <span class="donate-banner__icon" aria-hidden="true">⚠</span>
  <p class="donate-banner__text">
    <strong>Our country needs us.</strong> Every dollar fuels the fight for Michigan — don't wait.
  </p>
  <a routerLink="/donate" class="donate-banner__cta">Donate Now</a>
  <button (click)="dismiss()" class="donate-banner__close" aria-label="Dismiss donation banner">&times;</button>
</div>
